<template>
  <FilterParent
    class="primary"
    module="Integration"
    maxWidth="850"
    v-model="showIntegrationLogFilters"
  >
    <template #filterContent>
      <v-row class="ma-0">
        <v-col cols="6" class="pa-2">
          <DateField
            :inputProps="{
              dense: true,
              label: 'Select Log Date',
              'hide-details': 'auto',
            }"
            v-model="filterObject.created"
          />
        </v-col>

        <v-col v-if="isTosEventsTab" cols="6" class="pa-2">
          <MultiSelect
            label="Event Type"
            :items="eventTypeOptions"
            clearable
            hide-details="auto"
            v-model="filterObject.event_type"
          />
        </v-col>

        <v-col v-if="isCodecoTab" cols="6" class="pa-2">
          <MultiSelect
            label="Event Type"
            :items="codecoEventTypeOptions"
            clearable
            hide-details="auto"
            v-model="filterObject.event"
          />
        </v-col>

        <v-col v-if="!isCodecoTab" cols="6" class="Form-Columns">
          <v-switch
            :label="`Is Success : ${
              filterObject.is_success == true ? 'Yes' : 'No'
            }`"
            class="mt-1"
            hide-details="auto"
            v-model="filterObject.is_success"
          />
        </v-col>
      </v-row>
    </template>

    <template #filterAction>
      <v-btn
        color="secondary"
        depressed
        @click="
          $emit('resetFilters');
          showIntegrationLogFilters = false;
        "
      >
        Reset
      </v-btn>
      <v-btn
        color="primary"
        class="ml-2"
        depressed
        @click="
          $emit('applyFilters');
          showIntegrationLogFilters = false;
        "
      >
        Apply
      </v-btn>
    </template>
  </FilterParent>
</template>

<script>
import FilterParent from "@/components/General/FilterParent.vue";
import InputField from "@/components/FormBaseComponents/InputField.vue";
import DateField from "@/components/FormBaseComponents/DateField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";

export default {
  components: {
    FilterParent,
    InputField,
    DateField,
    MultiSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    bindingObject: {
      type: Object,
      default: () => ({}),
    },
    currentTab: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      orderStatusList: [],
      orderTypeList: [],
      eventTypeOptions: [
        "etoken-creation",
        "gate_in",
        "gate_out",
        "drop_gate_in",
        "drop_gate_out",
      ],
      codecoEventTypeOptions: ["gate_out", "gate_in"],
    };
  },

  computed: {
    showIntegrationLogFilters: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    filterObject: {
      get() {
        return this.bindingObject;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    isTosEventsTab() {
      return this.currentTab === 4;
    },
    isCodecoTab() {
      return this.currentTab === 5;
    },
    currentProfile() {
      let obj = localStorage.getItem("userProfile");
      if (obj) {
        return JSON.parse(obj);
      }
      return null;
    },
  },
  methods: {},
};
</script>
